import { localEditedButtonShapeValueVar } from "../../State";
import type { ButtonShape } from "../../types";

export const setEditedButtonShapeValue = (buttonShape: ButtonShape): void => {
    localEditedButtonShapeValueVar(buttonShape);
};

export const resetButtonShapeLocalVar = () => {
    localEditedButtonShapeValueVar(null);
};